// LABEL_FLOW_DESCRIPTION

// Contract Start Date Values

export const ENECO_SME_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN = 1;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_URGENT = 0;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX_URGENT = 14;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_SWITCH = 23;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_MOVING_OUT = 15;
export const ENECO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX = 90;

export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_URGENT = 0;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX_URGENT = 3;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_SWITCH = 23;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MIN_MOVING_OUT = 4;
export const OXXIO_ENERGY_FLOW_CONTRACT_START_DATE_IN_DAYS_MAX = 90;

export const CONTRACT_CONSIDERATION_PERIOD_IN_DAYS = 14;

// Max Usage Values
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_HIGH = 10000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_LOW = 10000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_GAS = 5000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_WARMTH = 10000;
export const ENECO_ENERGY_FLOW_MAX_USAGE_VALUE_WATER = 10000;

export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_HIGH = 80000;
export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_LOW = 80000;
export const ENECO_SME_ENERGY_FLOW_MAX_USAGE_VALUE_GAS = 30000;

export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_HIGH = 10000;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_ELECTRICITY_LOW = 10000;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_GAS = 5000;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_WARMTH = 0;
export const OXXIO_ENERGY_FLOW_MAX_USAGE_VALUE_WATER = 0;

// Misc
export const SOLAR_PANEL_OUTPUT = 240;
